<template>
  <div class="tiaojiefuheAll2">
    <div class="top">
      <MyTitle title="调节负荷" type="1" />
    </div>
    <div class="bottom-charts">
      <Chart :cdata="cdata" :width="'672'" :height="'380'" />
    </div>
  </div>
</template>

<script>
import Chart from "./chart.vue";
import MyTitle from "./MyTitle.vue";
import { dataInterface } from "@/api/dataInterfaceApi";
import * as echarts from "echarts5";
export default {
  components: {
    MyTitle,
    Chart,
  },
  data() {
    return {
      cdata: {
        title: {
		  text: "kW",
        },
        category: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月"],
        rateData: [],
        id: "carAddChart",
        legendData: [
          {
            name: "需求响应",
            // icon: "roundRect",
          },
          {
            name: "辅助服务",
            // icon: "roundRect",
          },
        ],
        yAxis: {
          name:'kW',
          nameTextStyle: {
            fontSize: 20,
          },
          axisLine: {
            //x轴坐标轴，false为隐藏，true为显示
            show: false,
          },
          axisLabel: {
            formatter: "{value} ",
            textStyle: {
              color: "rgba(255, 255, 255, 0.65)",
              fontSize: 20,
            },
          },
        },
        series: [
          {
            name: "需求响应",
            type: "bar",
            smooth: true,
            symbolSize: 1,
            // yAxisIndex: 1,
            itemStyle: {
             color: new echarts.graphic.LinearGradient(
               0,
               1,
               0,
               0,
               [
                 {
                   offset: 0,
                   color: "#15F5C9", // 0% 处的颜色
                 },
                 {
                   offset: 0.6,
                   color: "#1E927C", // 60% 处的颜色
                 },
                 {
                   offset: 1,
                   color: "#1B3633", // 100% 处的颜色
                 },
               ],
               false
             ),
            },
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          },
          {
            name: "辅助服务",
            type: "bar",
            smooth: true,

            symbolSize: 1,
            // yAxisIndex: 1,
            itemStyle: {
              // color: "#00A3FF",
			  color: new echarts.graphic.LinearGradient(
			    0,
			    1,
			    0,
			    0,
			   [
			               {
			                 offset: 0,
			                 color: "#0DB9E5", // 0% 处的颜色
			               },
			               {
			                 offset: 0.6,
			                 color: "#0C809D", // 60% 处的颜色
			               },
			               {
			                 offset: 1,
			                 color: "#0B4C5D", // 100% 处的颜色
			               },
			             ],
			    false
			  ),
            },
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          },
        ],
        // yAxisname:
        // "kW"
      },
      // show2: false,
      // batteryChargingData2: {}
    };
  },
  destroyed() {
    this.$bus.$off("updateTiaoJieFuHe");
  },
  mounted() {
    this.$bus.$on("updateTiaoJieFuHe", () => {
      // console.log(99776666)
      this.getData();
    });
    this.getData();
  },
  methods: {
    getData() {
      let params = {
        enCode: "powerplant-right-hdztjfh",
        "@station_id": localStorage.getItem("dummySattionId")
          ? localStorage.getItem("dummySattionId")
          : "c4b2359b5623446bbdcd282142d9767c",
        // "@station_id": '0217fb691abe4b3abb5adb4ed72b590b'
      };
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if (!res) return;
          // console.log("调节负荷", res)
          let demand_response_fz = [];
          let demand_response_xy = [];
          let xList = [];
          res.map((item) => {
            demand_response_fz.push(item.demand_response_fz);
            demand_response_xy.push(item.demand_response_xy);
            xList.push(item.mon.slice(1) + "月");
          });
          this.cdata.category = xList; //
          this.cdata.series[0].data = demand_response_xy;
          this.cdata.series[1].data = demand_response_fz;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
/* @import "./comm.scss"; */
.tiaojiefuheAll2 {
  .top {
    width: 672px;
    height: 55px;
    padding-top: 20px;
    padding-left: 20px;
  }

  .bottom-charts {
    width: 672px;
    height: 382px;
    margin-top: 65px;
    font-size: 24px;
    padding-left: 20px;
    // background-color: green;
  }
}
</style>